<div id="groupSelectorContainer" #selectorContainer></div>